"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleIconMobile = exports.iconContainer = exports.sectionTitleMobile = exports.header = exports.sectionHeaderMobile = exports.sectionLabelDesktop = exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _emotion = require("emotion");

var rootStyleDesktop = function rootStyleDesktop(alignItems, theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;flex-direction:column;min-width:fit-content;max-width:150px;margin-bottom:21px;padding-right:48px;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", theme.color.dark.copper, ";align-items:", alignItems, ";")
  );
};

exports.rootStyleDesktop = rootStyleDesktop;

var rootStyleMobile = function rootStyleMobile(alignItems, theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;flex-direction:column;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", theme.color.dark.copper, ";align-items:", alignItems, ";padding:0 15px;", expanded &&
    /*#__PURE__*/
    (0, _emotion.css)("background-color:", theme.color.dark.saturn, ";"))
  );
};

exports.rootStyleMobile = rootStyleMobile;
var sectionLabelDesktop =
/*#__PURE__*/
(0, _emotion.css)("margin-bottom:21px;");
exports.sectionLabelDesktop = sectionLabelDesktop;
var sectionHeaderMobile =
/*#__PURE__*/
(0, _emotion.css)("position:relative;padding:19px 0px;font-size:16px;font-weight:500;font-style:normal;font-stretch:normal;line-height:1.19;letter-spacing:normal;display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;width:100%;");
exports.sectionHeaderMobile = sectionHeaderMobile;
var header =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;padding:16px 0;");
exports.header = header;
var sectionTitleMobile =
/*#__PURE__*/
(0, _emotion.css)("flex:1;");
exports.sectionTitleMobile = sectionTitleMobile;
var iconContainer =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;right:0px;");
exports.iconContainer = iconContainer;

var toggleIconMobile = function toggleIconMobile(theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("fill:", theme.color.dark.white, ";width:10px;height:10px;left:50%;top:50%;transition:all 0.2s ease-in-out;opacity:1;", expanded && "\n    transition: all 0.2s ease-in-out;\n    transform: rotate(180deg);\n    opacity: 1;\n  ")
  );
};

exports.toggleIconMobile = toggleIconMobile;